const mixin = {
  methods: {
    
    navClick(params, index) {
      this.$router.push({path:params.href})
      this.$store.commit('set_nav_index', index)
    }
  }
}
export default mixin